import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";

function Cell({ language, onlyOne }) {
  const iconStyle = {
    borderRadius: 4,
    height: 150,
    width: 150,
    marginBottom: 10,
    backgroundColor: "#c3c3c3",
  };
  return (
    <div
      className={!onlyOne ? "my-5" : ""}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#ececec",
      }}
    >
      <Skeleton
        height={300}
        variant="rect"
        style={{ minWidth: 20, maxWidth: 20 }}
      />

      <div style={{ direction: language == "english" ? "ltr" : "rtl" }}>
        <Skeleton variant="rect" style={iconStyle} />
        <Skeleton style={{ backgroundColor: "#c3c3c3" }} />
        <Skeleton style={{ width: "40%", backgroundColor: "#c3c3c3" }} />
      </div>
      <div style={{ direction: language == "english" ? "ltr" : "rtl" }}>
        <Skeleton variant="rect" style={iconStyle} />
        <Skeleton style={{ backgroundColor: "#c3c3c3" }} />
        <Skeleton style={{ width: "40%", backgroundColor: "#c3c3c3" }} />
      </div>
      <Skeleton
        height={300}
        variant="rect"
        style={{ minWidth: 20, maxWidth: 20 }}
      />
    </div>
  );
}

export default Cell;
